import R from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import { q3Answers } from './QuestionnairesData';
import { q3Questions } from './QuestionnairesData';
import { q3QuestionsTeen } from './QuestionnairesData';
import modelo1 from '../assets/modelo1.png';
import modelo2 from '../assets/modelo2.png';
import modelo3 from '../assets/modelo3.png';
import modelo4 from '../assets/modelo4.png';
import {Form, FormGroup, ControlLabel, FormControl, ListGroup, ListGroupItem, Panel, Image, InputGroup} from 'react-bootstrap';
import {Checkbox, CheckboxGroup} from 'react-checkbox-group';
import {RadioGroup, Radio} from 'react-radio-group';
var FileSaver = require('file-saver');
import Footer from '../../modules/Footer.js';

export default class QuestionnaireBenziger extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {q3Questions: q3Questions, q3Answers: q3Answers, answers: Array(90).fill(null), aux: Array(90).fill(null)};
    this.loadAnswers();
    this.editable = this.props.editable !== false;
  }
  componentDidUpdate() {
    this.enableLeaveMessage();
  }
  componentWillUnmount() {
    window.onbeforeunload = null;
  }
  enableLeaveMessage() {
    if (this.props.canSave) {
      window.onbeforeunload = (event) => (event || window.event).returnValue = 'Tienes cambios sin guardar.'
    } else {
      window.onbeforeunload = null;
    }
  }

  loadAnswers(){
    var validAnswers;
    fetch(this.props.benzigerProgress, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          qId: this.props.qId
        }),
        responseType: 'json'
      })
      .then(response => response.json())
      .then(response => {
        if(response.code === 200){
          validAnswers = response.answers.slice();
          validAnswers.forEach(function(value, i) {
              if(value === "" || value === -1){
                validAnswers[i] = null;
              }
          });
          this.setState({ answers: validAnswers});
        }
      });
  }

  validateSubmit(){
      var valid = true;
      for(var i = 0; i < 71; i++){
        if(this.state.answers[i] == null){
          valid = false;
        }
      }
      if(valid){
        this.submitBenziger();
      } else {
        alert('Faltan campos de llenar.');
      }
  }

  submitBenziger(){
    var validAnswers = this.state.answers.slice();
    validAnswers.forEach(function(value, i) {
        if(value === null){
          validAnswers[i] = "";
        }
    });
    fetch(this.props.submitBenziger, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          answers: validAnswers,
          qId: this.props.qId
        }),
        responseType: 'json'
      })
      .then(response => response.json())
      .then(response => {
        if(response.code === 200){
          alert('El cuestionario fue guardado con exito!');
        } else {
          alert('Hubo un error, contacta al administrador.');
        }
      });
  }

  render() {
    const complete = false;
    const incompleteError = () => alert('Faltan campos de llenar.');
    let continueClasses = 'btn btn-lg btn-success';
    let exportClass = 'btn btn-lg btn-success';
    if (!complete) {
      continueClasses += ' disabled';
    }
    
    return (
      <form style={{ paddingRight: '20px', paddingLeft: '20px' }}>
        <h1>Cuestionario Benziger Thinking Style Assessment</h1>
        El perfil Benziger Thinking Style está diseñado para identificar sus patrones de pensamiento para captar, procesar y explicar información.
        <ul>
          <li>Está desarrollado a partir de la neurociencia e identica cuatro cuadrantes de pensamiento.</li>
          <li>Las respuestas que usted brinde ayudan a identificar su cuadrante dominante y por lo tanto NO hay respuestas buenas ni malas.</li>
          <li>Las respuestas que usted brinda son totalmente confidenciales.</li>
        </ul>
        {R.addIndex(R.map)(this.renderSection, R.zip(this.state.q3Questions, this.state.q3Answers))}
        <Footer>
          <button type='button' style={{ display: 'inline-block', margin: '0px 10px' }} className='btn btn-lg btn-info' onClick={this.submitBenziger}>{ 'Guardar' }</button>
          <button type='button' style={{ display: 'inline-block', margin: '0px 10px' }} className='btn btn-lg btn-success' onClick={this.validateSubmit}>{ 'Enviar' }</button>
          <br/>
        </Footer>
      </form>
    );
  }
  renderSection(section, index) {
    const questions = section[0];
    const answers = section[1];
    var style = "default";
    switch(index){
      case 0:
        style = "info";
        break;
      case 1:
        style = "info";
        break;
      case 2:
        style = "info";
        break;
      case 3:
        style = "info";
        break;
      case 4:
        style = "info";
        break;
      case 5:
        style = "info";
        break;
      case 6:
        style = "info";
        break;
      case 7:
        style = "info";
        break;
    }
    if(index== 7){
      return (
        <div>
          <br/>
          <Panel header={this.renderSectionName(index)} bsStyle={style}>
            {this.renderInstructions(index)}
            {R.addIndex(R.map)(this.renderQuestionLast, R.zip(questions, answers))}
          </Panel>
        </div>
      );
    }
    else{
      return (
      <div>
        <br/>
        <Panel header={this.renderSectionName(index)} bsStyle={style}>
          {this.renderInstructions(index)}
          {R.addIndex(R.map)(this.renderQuestion, R.zip(questions, answers))}
        </Panel>
      </div>
    );
    }
  }
  renderSectionName(section) {
    if (section === 0) return ( <h1>Datos Personales</h1> );
    if (section === 1) return ( <h1>Sección I. Información general</h1> );
    if (section === 2) return ( <h1>Sección II. Usted de niño</h1> );
    if (section === 3) return ( <h1>Sección III. Labores</h1> );
    if (section === 4) return ( <h1>Sección IV. Su vida de hogar y tiempo libre</h1> );
    if (section === 5) return ( <h1>Sección V. Percepción general de mí mismo</h1> );
    if (section === 6) return ( <h1>Sección VI. Estado emocional</h1> );
    if (section === 7) return ( <h1>72) Nivel de estrés</h1> );
  }
  renderInstructions(section) {
    if (section === 1) return ( 
      <div>
      </div> );
    if (section === 2) return ( 
      <div>
        <p>Instrucciones para responder las preguntas 13 a 21.</p>
        <ul>
          <li>Seleccione las 3 respuestas que mejor lo describen.</li>
          <li>Primero seleccione la respuesta que lo describe en primer lugar.</li>
          <li>Despues, seleccione la respuesta que lo describe en segundo lugar.</li>
          <li>Por ultimo, seleccione la respuesta que lo describe en tercer lugar.</li>
        </ul>
      </div> );
    if (section === 3) return (
      <div>
        <p>Instrucciones para responder las preguntas 25 a 40.</p>
        <ul>
          <li>Seleccione las 3 respuestas que mejor lo describen.</li>
          <li>Primero seleccione la respuesta que lo describe en primer lugar.</li>
          <li>Despues, seleccione la respuesta que lo describe en segundo lugar.</li>
          <li>Por ultimo, seleccione la respuesta que lo describe en tercer lugar.</li>
        </ul>
      </div> );
    if (section === 4) return (
      <div>
        <p>Instrucciones para responder las preguntas 41 a 49.</p>
        <ul>
          <li>Seleccione las 3 respuestas que mejor lo describen.</li>
          <li>Primero seleccione la respuesta que lo describe en primer lugar.</li>
          <li>Despues, seleccione la respuesta que lo describe en segundo lugar.</li>
          <li>Por ultimo, seleccione la respuesta que lo describe en tercer lugar.</li>
        </ul>
      </div> );
    if (section === 5) return (
      <div>
        <p>Instrucciones para responder las preguntas 51 a 61.</p>
        <ul>
          <li>Seleccione las 3 respuestas que mejor lo describen.</li>
          <li>Primero seleccione la respuesta que lo describe en primer lugar.</li>
          <li>Despues, seleccione la respuesta que lo describe en segundo lugar.</li>
          <li>Por ultimo, seleccione la respuesta que lo describe en tercer lugar.</li>
        </ul>
      </div> );
    if (section === 6) return ( <div></div> );
    if(section ===7) return (
      <div>
        <p>Instrucciones para responder a la pregunta 72.</p>
        <ul>
          <li>Indique cuál de los siguientes acontecimientos importantes ha ocurrido en su vida durante los 12 meses pasados.</li>
          <li>Indique el numero de veces en su respuesta.</li>
        </ul>
      </div>);
  }
  renderQuestion(question, index) {
    const questionStmt = question[0];
    const options = question[1];
    const questionNumber = options[1];
    const title = (
      <h4>{questionStmt}</h4>
    );

    return (
    <div>
      <Panel header={title}>
        {this.renderOptions(options, index)}
      </Panel>
    </div> );
  }

  renderQuestionLast(question, index) {
    const questionStmt = question[0];
    const options = question[1];
    const title = questionStmt;
    const questionNumber = options[1];

    const divStyle = {
      width:  '400px'
    };
    return (
      <div>
        <FormGroup>
          <InputGroup>
            <InputGroup.Addon style={divStyle}>{title}</InputGroup.Addon>
              {this.renderOptions(options, index)}
          </InputGroup>
        </FormGroup>
      </div>
      );
  }
  renderOptions(options, index) {
    const inputType = options[0];
    const questionNumber = options[1];
    options = options.slice(2);
    var optionsSelect = [];
    var len = options.length;
    var noticeM = '';
    var noticeN = '';
    var notices = [];
    notices[0] = '';
    notices[1] = '';
    notices[2] = '';
    var noticeL = '';
    var modelosV = [modelo1, modelo2, modelo3, modelo4];
    var lenAux = 0;
    var optionsCheckboxAux;
    var optionsCheckbox = [];
    var lenModels = modelosV.length;
    var lenAnswers = 0;

    if (this.state.aux[questionNumber-1] !== null){
      lenAux = this.state.aux[questionNumber-1].length;
    }
    for (var i = 0; i < len; i++) {
      if(this.state.aux[questionNumber-1] !== null){
        for (var j = 0; j <lenAux; j++){
          if(this.state.aux[questionNumber-1][j].type == 3){
            if(this.state.aux[questionNumber-1][j].value == i){
              if(j==0){
                notices[0] = this.state.aux[questionNumber-1][j].label;
              }
              else if(j==1){
                notices[1] = this.state.aux[questionNumber-1][j].label;
              }
              else{
                notices[2] = this.state.aux[questionNumber-1][j].label;
              }
            }
          }
        }
      }
      optionsSelect.push({
          value: i,
          label: options[i]
      });
    }
    if (inputType === 0)
      return (
      <FormGroup>
        <FormControl
          type="text"
          value={this.state.answers[questionNumber-1]|| ''}
          placeholder=""
          onChange={this.handleInputChange.bind(this, questionNumber)}
        />
      </FormGroup>
    );
    else if (inputType === 1)
      return (
      <FormGroup>
        <FormControl
          type="number"
          value={this.state.answers[questionNumber-1] || ""}
          placeholder=""
          onChange={this.handleNumChange.bind(this, questionNumber)}
          min='0'
        />
      </FormGroup>
    );
    else if (inputType === 2){
      optionsCheckbox = [];
      var radioName = "question"+questionNumber;
      for (var i = 0; i < len; i++) {
            optionsCheckboxAux =(<label><Radio value={i}/> {options[i]}&#8195;&#8195;</label>);
            optionsCheckbox.push(optionsCheckboxAux);
      }
      return (
        <RadioGroup name={radioName} selectedValue={this.state.answers[questionNumber-1]} onChange={this.handleRadioChange.bind(this, questionNumber)}>
          {optionsCheckbox}
        </RadioGroup>
      );
    }
    else if (inputType === 3){
      if(this.state.answers[questionNumber-1] != null){
        lenAnswers = this.state.answers[questionNumber-1].length;
      }
      notices[0] = '';
      notices[1] = '';
      notices[2] = '';
      for(var i = 0; i< lenAnswers; i++){
        notices[i] = this.state.answers[questionNumber-1][i];
      }
      for (var i = 0; i < lenModels; i++) {
            optionsCheckboxAux =(<label><Checkbox value={i}/><img width='100px' src={modelosV[i]} />&#8195;&#8195;&#8195;&#8195;&#8195;&#8195;&#8195;&#8195;&#8195;&#8195;&#8195;</label>);
            optionsCheckbox.push(optionsCheckboxAux);
      }
      return (
        <div>
          <ListGroup>
              <ListGroupItem bsStyle="success">MEJOR me describe:&#8195;<img width='50px' src={modelosV[notices[0]]} alt=""/></ListGroupItem>
              <ListGroupItem bsStyle="danger">NADA me describe:&#8195;&#8195;<img width='50px' src={modelosV[notices[1]]} alt=""/></ListGroupItem>
          </ListGroup>
          <CheckboxGroup
            name="form-field-6"
            value={this.state.answers[questionNumber-1]}
            onChange={this.handleCheckboxChange2.bind(this, questionNumber)}>
            {optionsCheckbox}
          </CheckboxGroup>
        </div>
      );
    }
    else if (inputType === 4){
      if(this.state.answers[questionNumber-1] != null){
        lenAnswers = this.state.answers[questionNumber-1].length;
      }
      notices[0] = '';
      notices[1] = '';
      notices[2] = '';
      for(var i = 0; i< lenAnswers; i++){
        notices[i] = this.state.answers[questionNumber-1][i];
      }
      optionsCheckbox = [];
      for (var i = 0; i < len; i++) {
            optionsCheckboxAux =(<label><Checkbox value={options[i]}/> {options[i]}&#8195;&#8195;</label>);
            optionsCheckbox.push(optionsCheckboxAux);
      }
      return (
        <div>
          <ListGroup>
            <ListGroupItem bsStyle="success">a) Lo primero que me describe es:&#8195;&#8195;&#8195;<b>{notices[0]|| ''}</b></ListGroupItem>
            <ListGroupItem bsStyle="warning">b) Lo segundo que me describe es:&#8195;&#8195;<b>{notices[1] || ''}</b></ListGroupItem>
            <ListGroupItem bsStyle="danger">c) Lo tercero que me describe es:&#8195;&#8195;&#8195;<b>{notices[2] || ''}</b></ListGroupItem>
          </ListGroup>
          <p>Seleccione tres opciones del siguiente menu</p>
          <CheckboxGroup
            name="form-field-6"
            value={this.state.answers[questionNumber-1]}
            onChange={this.handleCheckboxChange3.bind(this, questionNumber)}>
            {optionsCheckbox}
          </CheckboxGroup>
        </div>
      );
    }
    else if (inputType === 5){
      optionsCheckbox = [];
      for (var i = 0; i < len; i++) {
            optionsCheckboxAux =(<label><Checkbox value={i}/> {options[i]}&#8195;&#8195;</label>);
            optionsCheckbox.push(optionsCheckboxAux);
      }
      return (
        <CheckboxGroup
          name="form-field-6"
          value={this.state.answers[questionNumber-1]}
          onChange={this.handleCheckboxChange.bind(this, questionNumber)}>
          {optionsCheckbox}
        </CheckboxGroup>
      );
    }
    else if (inputType === 6){
      optionsCheckbox = [];
      for (var i = 0; i < len; i++) {
            optionsCheckboxAux =(<label><Checkbox value={options[i]}/> {options[i]}&#8195;&#8195;</label>);
            optionsCheckbox.push(optionsCheckboxAux);
      }
      return (
        <CheckboxGroup
          name="form-field-6"
          value={this.state.answers[questionNumber-1]}
          onChange={this.handleCheckboxChange6.bind(this, questionNumber)}>
          {optionsCheckbox}
        </CheckboxGroup>
      );
    }
    else if (inputType === 7) 
      return (
        <FormControl type="text" value={this.state.answers[questionNumber-1]|| '0'} placeholder="" onChange={this.handleNumChange.bind(this, questionNumber)} min='0'/>
      );
    else if (inputType === 8){
      optionsCheckbox = [];
      var radioName = "question"+questionNumber;
      if(this.state.answers[questionNumber-2] !== null){
        len = this.state.answers[questionNumber-2].length;
        for (var i = 0; i < len; i++) {
            optionsCheckboxAux =(<label><Radio value={this.state.answers[questionNumber-2][i]} /> {this.state.answers[questionNumber-2][i]}&#8195;&#8195;</label>);
            optionsCheckbox.push(optionsCheckboxAux);
        }
      }
      return (
        <RadioGroup name={radioName} selectedValue={this.state.answers[questionNumber-1]} onChange={this.handleRadioChange.bind(this, questionNumber)}>
          {optionsCheckbox}
        </RadioGroup>
      );
    }
    else if (inputType === 9){
      optionsCheckbox = [];
      var radioName = "question"+questionNumber;
      for(var i = 55; i < (questionNumber); i++){
        if(this.state.answers[i-1] !== null){
          len = this.state.answers[i-1].length;
          if(len>0){
            optionsCheckboxAux =(<label><Radio value={this.state.answers[i-1][0]} /> {this.state.answers[i-1][0]}&#8195;&#8195;</label>);
            optionsCheckbox.push(optionsCheckboxAux);
          }
        }
      }
      return (
        <RadioGroup name={radioName} selectedValue={this.state.answers[questionNumber-1]} onChange={this.handleRadioChange.bind(this, questionNumber)}>
          {optionsCheckbox}
        </RadioGroup>
      );
    }
  }


  handleInputChange(questionNumber, input) {
    const answersUpdated = this.state.answers.slice();
    answersUpdated[questionNumber-1] = input.target.value;
    this.setState({answers: answersUpdated});
  }

  handleNumChange(questionNumber, input) {
    const answersUpdated = this.state.answers.slice();
    var answer = Math.max(input.target.value,0);
    answersUpdated[questionNumber-1] = answer;
    this.setState({answers: answersUpdated});
    if((questionNumber) == 3 && answer >= 18){
      this.setState({q3Questions: q3Questions});
    } else {
      this.setState({q3Questions: q3QuestionsTeen});
    }
  }


  handleRadioChange(questionNumber, select){
    const answersUpdated = this.state.answers.slice();
    answersUpdated[questionNumber-1] = select;
    this.setState({answers: answersUpdated});
  }

  handleCheckboxChange(questionNumber, select) {
    const answersUpdated = this.state.answers.slice();
    answersUpdated[questionNumber-1] = select;
    this.setState({answers: answersUpdated});
  }

  handleCheckboxChange6(questionNumber, select) {
    const answersUpdated = this.state.answers.slice();
    answersUpdated[questionNumber-1] = select;
    if ( select.length <= 6 ) {
        this.setState({answers: answersUpdated});
    }
    else{
      alert("Máximo 6 opciones");
    }
  }

  handleCheckboxChange2(questionNumber, select) {
    const answersUpdated = this.state.answers.slice();
    answersUpdated[questionNumber-1] = select;
    if ( select.length <= 2 ) {
        this.setState({answers: answersUpdated});
    }
    else{
      alert("Máximo 2 opciones");
    }
  }

  handleCheckboxChange3(questionNumber, select) {
    const answersUpdated = this.state.answers.slice();
    answersUpdated[questionNumber-1] = select;
    if ( select.length <= 3 ) {
        this.setState({answers: answersUpdated});
    }
    else{
      alert("Máximo 3 opciones");
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/questionnaires/QuestionnaireBenziger.jsx